import { experimentCore } from './services/experimentCore'
import { confirmExperiments } from './services/confirmExperiments'

export { EXPERIMENT_SLUGS } from './constants/experimentConstants'
export { featureFlags } from './services/featureFlags'
export { fetchActiveExperiment } from './services/fetchActiveExperiment'
export { useExperimentVariation } from './hooks/useExperimentVariation'
export {
    experimentCookieJar,
    experimentSlugsCookieStorage,
} from './services/experimentSlugsCookieStorage'

export const experiments = {
    init: experimentCore.init,
    getAllExperimentsData: experimentCore.getAllExperimentsData,
    ...confirmExperiments,
}
